import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui-kit/dropdown-menu';
import { Button } from '@/components/ui-kit/button';
import { EllipsisVertical, Repeat2, Trash } from 'lucide-react';
import { useState } from 'react';
import { ReembedKb } from '@/modules/gpt-chats/components/knowledge-base/components/reembed-kb/reembed-kb';
import { DeleteKb } from './kb-delete';
import { KBType } from '@/modules/gpt-chats/models/kb';
import { useTranslation } from 'react-i18next';

export const FolderRowActionDropdown = ({
  documentId,
  kbType,
  folderId,
}: {
  documentId: string;
  kbType: KBType;
  folderId: string;
}) => {
  const { t } = useTranslation();
  const [isReEmbedOpen, setIsReEmbedOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="-mt-1 h-fit w-fit rounded-full p-2">
            <EllipsisVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setIsReEmbedOpen(true)}>
            <Repeat2 className="mr-2 aspect-square w-4" />
            {t('RE_EMBED_BUTTON')}
          </DropdownMenuItem>

          <DropdownMenuItem className="!text-error" onClick={() => setIsDeleteOpen(true)}>
            <Trash className="mr-2 aspect-square w-4" />
            <span>{t('DELETE')}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ReembedKb
        kbs={[{ id: documentId, type: kbType }]}
        open={isReEmbedOpen}
        onOpenChange={setIsReEmbedOpen}
      />

      <DeleteKb
        folderId={folderId}
        kbId={documentId}
        kbType={kbType}
        open={isDeleteOpen}
        onOpenChange={setIsDeleteOpen}
      />
    </>
  );
};
